<template>
    <div class="DshSteps">
        <Steps
            :current="current"
            :direction="ownPropsObj._direction"
            :status="ownPropsObj._status"
            :size="ownPropsObj._size"
        >
            <Step
                class="DshSteps-item"
                v-for="(stepItem, stepIndex) in list"
                :key="stepItem.type || stepItem._id || stepItem._key || stepIndex"
                :status="stepItem.status"
                :title="stepItem.name"
                :content="stepItem.description"
                :icon="stepItem.icon"
                @click.native="clickStepItem(stepItem, stepIndex)"
            ></Step>
        </Steps>
    </div>
</template>

<script>
    export default {
        name: "DshSteps",
        props: {
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            stepShowFunc: Function,
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                current: 0 // 当前步骤，从 0 开始计数
            };
        },
        computed: {
            ownPropsObj () {
                return {
                    _status: "process", // 当前步骤的状态，可选值为wait、process、finish、error
                    _size: undefined, // 步骤条的尺寸，可选值为small或者不写
                    _direction: "vertical", // 步骤条的方向，可选值为horizontal（水平）或vertical（垂直）
                    ...this.propsObj
                };
            }
        },
        created () {},
        methods: {
            clickStepItem (stepItem, stepIndex) {
                if (!this.stepShowFunc || this.stepShowFunc(stepItem, stepIndex)) {
                    if (this.current !== stepIndex) {
                        this.current = stepIndex;
                        this.$emit("change", stepItem, stepIndex);
                    }
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshSteps.vue